import { TermsOfUseFooter } from "./TermsOfUseFooter";
export default TermsOfUseFooter;



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/TermsOfUseFooter/index.js